<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-10">
          <div class="big-title">{{ $t('yourApplications') }}</div>
          <div class="apps">
            <div class="app">
              <a href="http://www.intratone.info/" ztarget="_blank"><img class="imghover" src="../assets/apps/intratone.png"></a>
              <div class="site" style="margin-top: 10px;"><a href="http://www.intratone.info/" ztarget="_blank">Intratone.info</a></div>
            </div>
            <div class="app">
              <a href="http://www.organigramme.info/" ztarget="_blank"><img class="imghover" src="../assets/apps/organigramme.png"></a>
              <div class="site" style="margin-top: 10px;"><a href="http://www.organigramme.info/" ztarget="_blank">Organigramme.info</a></div>
            </div>
          </div>
          <div class="big-title">{{ $t('toolsProg') }}</div>
          <div class="setups">
            <table>
              <tbody><tr>
                <td>
                  <input type="image" src="static/img/tools-32.png" style="height: 32px; width: 32px">
                </td>
                <td>
                  <a class="btn btn-light" href="#/setup" style="color:#000;">{{ $t('installAndTest') }}</a>
                </td>
              </tr>
              <tr style="display: none;">
                <td>
                  <input type="image" src="static/img/macosx.png" style="height: 32px; width: 32px">
                </td>
                <td>
                  <a href="setup/macosx/programmateur.dmg">{{ $t('installAndTest') }}</a>
                </td>
              </tr>
            </tbody></table>
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  created: function () {
    document.title = this.$i18n.t(`titleProg`);
  }
}
</script>

<style scoped>
.big-title {
    width:1024px; position: relative;
    margin:20px auto;
    text-align: left;
    font-weight: bold;
    font-size: 26px;
    padding:10px 15px;
    border-bottom: 1px solid #ddd;
    font-family: 'Lucida Grande', sans-serif;
}
.setups {
    width:1024px; position: relative;
    margin:0 auto;
    margin-top: 30px;
    padding-left: 50px;
}
.setups a {
    color: #11a9cc;
}
.setups table {
    width: auto;
}
.setups table td {
    padding: 5px 10px;
}
.apps {
    width:1024px; position: relative;
    margin:0 auto;
}
.apps:after {
    clear: both;
    display: block;
    height: 10px;
    content:"";
}
.apps .app {
    width:200px; margin:5px;
    position: relative; float: left; height: 200px;
    text-align:center;
}
.apps .app .img {
    width:150px; height:150px; margin:5px 25px;
}
.apps .app .site {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}
.apps .app .site a {
    font-family: 'Lucida Grande', sans-serif;
    color: #11a9cc !important;
}
</style>
